export default __webpack_public_path__ + "static/media/heroBg.5e148c47.mp4";